module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/css-3644e6087ee6f394e15b48b3d24ddb21.svg";